import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RequestStateModel } from '../models/request_state_model';

/**
 * @description Command to set the request state of campus preferences update
 * If isRequestPending is true, the request is pending and action will be locked
 */
export type CampusPreferencesRequestStateCommand = (isRequestPending: boolean) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'campusPreferencesRequestStateCommand',
    function campusPreferencesRequestStateCommand(
      defineCommandORM: IDefineCommand,
      ngRequestStateModel: RequestStateModel
    ) {
      'use strict';

      return defineCommandORM('campusPreferencesRequestStateCommand', (deferred, isRequestPending: boolean) => {
        ngRequestStateModel.write({ isCampusPreferencePending: isRequestPending });
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/request_state/commands/campus_preferences_request_state_command.ts